import React, { useEffect, useRef } from 'react';

// styles
import { ToastBox, Content } from './styles';
import { TAB_INDEX } from 'shared/constants';
import useKeyboardClick from 'shared/hooks/useKeyboardClick';

interface ICartNudgeProps {
  content: string;
  actionText: string;
  onClick?: VoidFunction;
  className?: string;
  IconComponent?: React.ReactNode;
}

const CartNudge = ({
  content,
  actionText,
  onClick,
  className = '',
  IconComponent,
}: ICartNudgeProps) => {
  const emptyActionText = actionText.length === 0;
  const toastRef = useRef<HTMLDivElement>(null);
  const closeKeyboardProps = useKeyboardClick(onClick);
  // Focus the snackbar when it appears so VoiceOver reads it
  useEffect(() => {
    if (toastRef.current) {
      // Small delay to ensure DOM is ready
      const timer = setTimeout(() => {
        toastRef.current?.focus();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <ToastBox
      ref={toastRef}
      onClick={onClick}
      className={className}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      tabIndex={TAB_INDEX.ACTION_VISIBILITY}
    >
      <div className="toast-mob-container">
        {IconComponent && (
          <div className="toast-icon" aria-hidden="true">
            {IconComponent}
          </div>
        )}
        <Content emptyActionText={emptyActionText} data-test="nudge-content">
          {content}
        </Content>
        {actionText && (
          <div className="action" {...closeKeyboardProps}>
            {actionText}
          </div>
        )}
      </div>
    </ToastBox>
  );
};

export default CartNudge;
